module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir13-b4b0f6e96ffdc2080ca62ad5b7b67b3c.jpg";